module.exports = __webpack_public_path__ + "img/judge.0278f91a.svg";